import React, {useEffect} from 'react';
import Aos from 'aos';
import "aos/dist/aos.css";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { FaMobileScreen } from "react-icons/fa6";
import { FaEnvelope } from "react-icons/fa6";
import { FaLocationDot } from "react-icons/fa6";



function Contact() {
    useEffect(() => {
            Aos.init({ duration: 2000 });
        }, []);

  return (
    <div className='contactSection'>
      <h3 className='sectionHeading'>Contact us</h3>
      <span className='headingAfterLine'></span>
      <p className='textAfterHeading'>Get in touch with below contact information</p>
      {/* <div className='shadowEffect'>
      <Row>
        <Col md={8}>
            <div className="formWrap">
            <Form>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Full Name</Form.Label>
                        <Form.Control type="text" placeholder="Full Name" />
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-3">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" placeholder="Email" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Form.Group className="mb-3">
                            <Form.Label>Subject</Form.Label>
                            <Form.Control type="text" placeholder="Subject" />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Form.Group className="mb-4">
                        <Form.Label>Message</Form.Label>
                        <Form.Control as="textarea" rows={5} />
                    </Form.Group>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Button variant="primary" className='submitBtn'>SUBMIT</Button>
                </Col>
            </Row>
            </Form>
            </div>
        </Col>
        <Col md={4}>
            <div className="contactInfoWrap">
                <ul>
                    <li>
                        <div className="contactInfoHeading">Address</div>
                        <div className="contactInfoText">No 105 1st Floor Padmavati Aishwaryam Apartment JP Nagar 7th phase Bangalore – 560078</div>
                    </li>
                    <li>
                        <div className="contactInfoHeading">Phone</div>
                        <div className="contactInfoText">Mr. Gopi - 98868 35566</div>
                        <div className="contactInfoText">Mr. Thippeswamy - 99166 53927</div>
                    </li>
                    <li>
                        <div className="contactInfoHeading">E-mail</div>
                        <div className="contactInfoText">parishramasportsacademy23@gmail.com</div>
                    </li>
                </ul>
            </div>
        </Col>
      </Row>
    </div> */}
    <div className="boxMainwrap">
    <Row>
        <Col md={4}>
            <div className="boxWrap" data-aos="fade-left">
                <FaLocationDot className='iconImg' />
                <div className="contactInfoHeading">Address</div>
                <div className="contactInfoText">No 105 1st Floor Padmavati Aishwaryam Apartment JP Nagar 7th phase Bangalore – 560078</div>
            </div>
        </Col>
        <Col md={4}>
            <div className="boxWrap bg" data-aos="fade-up">
                <FaMobileScreen className='iconImg' />
                <div className="contactInfoHeading">Phone</div>
                <div className="contactInfoText"><a href="tel:+919739275828"> Mr. Manjunatha - 97392 75828</a></div>
                <div className="contactInfoText"><a href="tel:+917975808067"> Mr. Gopi - 79758 08067</a></div>
                <div className="contactInfoText"><a href="tel:+919916653927"> Mr. Thippeswamy - 99166 53927</a></div>
                <div className="contactInfoText"><a href="tel:+919482155361"> Mr. Madesh Chandra - 94821 55361</a></div>
            </div>
        </Col>
        <Col md={4}>
            <div className="boxWrap" data-aos="fade-right">
                <FaEnvelope className='iconImg' />
                <div className="contactInfoHeading">E-mail</div>
                <div className="contactInfoText">parishramasportsacademy23@gmail.com</div>
            </div>
        </Col>
    </Row>
    </div>
    </div>
  )
}

export default Contact
